// extracted by mini-css-extract-plugin
export default {"productDescription":"Oba-z","featuredDescription":"Pba-z","description":"Qba-z","more":"Rba-z","descriptionSku":"Sba-z"};